var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.62712 0 0.410973 4.983 0.0188599 11.25H8.24421V9C8.24421 8.586 8.58074 8.25 8.99539 8.25H15.0048C15.4194 8.25 15.7559 8.586 15.7559 9V15C15.7559 15.414 15.4194 15.75 15.0048 15.75H8.99539C8.58074 15.75 8.24421 15.414 8.24421 15V12.75H0.0188599C0.410973 19.017 5.62712 24 12.0001 24C18.6269 24 24.0189 18.6165 24.0189 12C24.0189 5.3835 18.6269 0 12.0001 0Z",
    fill: "#010813"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUber);
export default __webpack_public_path__ + "static/media/uber.9d618f95.svg";
export { ForwardRef as ReactComponent };